import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
// Models
import mScenario from 'models/scenario';
// Custom
import { scenariosShape } from 'constants/PropTypesShapes';
import ResourceSelectFieldFilter from 'components/filters/ResourceSelectFieldFilter';

const ScenarioSelectFieldFilter = ({ scenarioId, scenarios, onChange }) => {
  const sortedScenarios = mScenario.sortElements(scenarios.elements);

  return (
    <ResourceSelectFieldFilter
      labelId="field.scenario"
      resourceId={scenarioId}
      resources={sortedScenarios}
      displayKey="name"
      onChange={onChange}
    />
  );
};

ScenarioSelectFieldFilter.propTypes = {
  scenarioId: PropTypes.number,
  scenarios: scenariosShape.isRequired,
  onChange: PropTypes.func.isRequired,
};

ScenarioSelectFieldFilter.defaultProps = {
  scenarioId: null,
};

const mapStateToProps = (state) => ({
  scenarios: state.installationScenario.list,
});

module.exports = connect(
  mapStateToProps,
  null,
)(ScenarioSelectFieldFilter);



// WEBPACK FOOTER //
// ./routes/app/routes/installations/assets/scenarios/ScenarioSelectFieldFilter.js